import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "homeview" */ "../views/HomeView.vue"),
  },
  {
    path: "/home",
    name: "home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "homeview" */ "../views/HomeView.vue"),
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/ts",
    name: "ts",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ts" */ "../views/Township.vue"),
  },
  {
    path: "/cat",
    name: "cat",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "cat" */ "../views/Category.vue"),
  },
  {
    path: "/bank",
    name: "bank",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "bank" */ "../views/BankType.vue"),
  },
  {
    path: "/ttype",
    name: "ttype",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ttype" */ "../views/ToolType.vue"),
  },
  {
    path: "/sertype",
    name: "sertype",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "sertype" */ "../views/ServiceType.vue"),
  },
  {
    path: "/service",
    name: "service",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "service" */ "../views/Service.vue"),
  },
  {
    path: "/servicelist",
    name: "servicelist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "servicelist" */ "../views/ServiceList.vue"),
  },
  {
    path: "/sale",
    name: "sale",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "sale" */ "../views/Sale.vue"),
  },
  {
    path: "/salelist",
    name: "salelist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "salelist" */ "../views/SaleList.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "purchase" */ "../views/Purchase.vue"),
  },
  {
    path: "/spurchaselist",
    name: "spurchaselist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "purchaselist" */ "../views/PurchaseList.vue"
      ),
  },
  {
    path: "/purchaselist",
    name: "purchaselist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "purchaselist" */ "../views/NPurchaseList.vue"
      ),
  },
  {
    path: "/ua",
    name: "ua",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ua" */ "../views/UserAccount.vue"),
  },
  {
    path: "/surveyt",
    name: "surveyt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "surveyt" */ "../views/SurveyType.vue"),
  },
  {
    path: "/ut",
    name: "ut",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ut" */ "../views/Unit.vue"),
  },
  {
    path: "/pt",
    name: "pt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pt" */ "../views/Product.vue"),
  },
  {
    path: "/branch",
    name: "branch",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "branch" */ "../views/Branch.vue"),
  },
  {
    path: "/comp",
    name: "comp",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "comp" */ "../views/Company.vue"),
  },
  {
    path: "/ic",
    name: "income",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "income" */ "../views/Income.vue"),
  },
  {
    path: "/ep",
    name: "expense",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "expense" */ "../views/Expense.vue"),
  },
  {
    path: "/py",
    name: "payment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "payment" */ "../views/Payment.vue"),
  },
  {
    path: "/attendance",
    name: "attendance",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "attendance" */ "../views/Attendance.vue"),
  },
  {
    path: "/finance",
    name: "finance",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "finance" */ "../views/Finance.vue"),
  },
  {
    path: "/survey",
    name: "survey",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "survey" */ "../views/Survey.vue"),
  },
  {
    path: "/reportbt",
    name: "reportbt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reportbt" */ "../views/ReportBankType.vue"),
  },
  {
    path: "/soh",
    name: "soh",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportsoh" */ "../views/ReportStockOnHand.vue"
      ),
  },
  {
    path: "/daily/soh",
    name: "/daily/soh",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "ReportStockOnHandDaily" */ "../views/ReportStockOnHandDaily.vue"
      ),
  },
  {
    path: "/reportsale",
    name: "reportsale",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reportsale" */ "../views/ReportSale.vue"),
  },
  {
    path: "/reportpur",
    name: "reportpur",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reportpur" */ "../views/ReportPurchase.vue"),
  },
  {
    path: "/reportrawgoods",
    name: "reportrawgoods",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportrawgoods" */ "../views/ReportRawGoods.vue"
      ),
  },
  {
    path: "/reportcapital",
    name: "reportcapital",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportcapital" */ "../views/ReportCapital.vue"
      ),
  },
  {
    path: "/ri",
    name: "ri",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportincome" */ "../views/ReportIncome.vue"
      ),
  },
  {
    path: "/re",
    name: "re",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportexpense" */ "../views/ReportExpense.vue"
      ),
  },
  {
    path: "/profitloss",
    name: "profitloss",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportprofitloss" */ "../views/ReportProfitLoss.vue"
      ),
  },
  {
    path: "/plmonth",
    name: "plmonth",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "plmonth" */ "../views/ReportProfitLossMonth.vue"
      ),
  },
  {
    path: "/voucher",
    name: "voucher",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "voucher" */ "../views/Voucher.vue"),
  },
  {
    path: "/quotation",
    name: "quotation",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "quotation" */ "../views/VoucherQuotation.vue"
      ),
  },
  {
    path: "/voucheri",
    name: "voucheri",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "voucheri" */ "../views/VoucherI.vue"),
  },
  {
    path: "/voucherideb",
    name: "voucherideb",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "voucherideb" */ "../views/VoucherIDeb.vue"),
  },
  {
    path: "/voucherip",
    name: "voucherip",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "voucherip" */ "../views/VoucherIPay.vue"),
  },
  {
    path: "/vouchericash",
    name: "vouchericash",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "vouchericash" */ "../views/VoucherICash.vue"
      ),
  },
  {
    path: "/su",
    name: "su",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "su" */ "../views/UserAccountSupp.vue"),
  },
  {
    path: "/sala",
    name: "sala",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "su" */ "../views/Salary.vue"),
  },
  {
    path: "/reportseries",
    name: "reportseries",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportseries" */ "../views/ReportSeries.vue"
      ),
  },
  {
    path: "/delivery",
    name: "delivery",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Delivery" */ "../views/Delivery.vue"),
  },
  {
    path: "/returnout",
    name: "returnout",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "returnout" */ "../views/ReturnOut.vue"),
  },
  {
    path: "/returnin",
    name: "returnin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "returnin" */ "../views/ReturnIn.vue"),
  },
  {
    path: "/returninlist",
    name: "returninlist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "returninlist" */ "../views/ReturnInList.vue"
      ), //ReturnInList
  },
  {
    path: "/returnoutlist",
    name: "returnoutlist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "returnoutlist" */ "../views/ReturnOutList.vue"
      ),
  },
  {
    path: "/debitcredit",
    name: "debitcredit",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "debitcredit" */ "../views/ReportDebitCredit.vue"
      ),
  },
  {
    path: "/gross",
    name: "gross",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ReportGross" */ "../views/ReportGross.vue"),
  },
  {
    path: "/quotationsale",
    name: "quotationsale",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "quotationsale" */ "../views/QuotationSale.vue"
      ),
  },
  {
    path: "/quotationlist",
    name: "quotationlist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "quotationlist" */ "../views/QuotationList.vue"
      ),
  },
  {
    path: "/grossbill",
    name: "grossbill",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "grossbill" */ "../views/ReportGrossBillService.vue"
      ),
  },
  {
    path: "/cashtransfer",
    name: "cashtransfer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "cashtransfer" */ "../views/CashTransfer.vue"
      ),
  },
  {
    path: "/itransfer",
    name: "itransfer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "itransfer" */ "../views/StoreTransfer.vue"),
  },
  {
    path: "/rovoucherlist",
    name: "rovoucherlist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "rovoucherlist" */ "../views/ReturnOutVoucherList.vue"
      ),
  },
  {
    path: "/uiaccept",
    name: "uiaccept",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "uiaccept" */ "../views/UiAccept.vue"),
  },
  {
    path: "/cpt",
    name: "capital",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Capital" */ "../views/Capital.vue"),
  },
  {
    path: "/rwi",
    name: "rawitem",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "RawItem" */ "../views/RawItem.vue"),
  },
  {
    path: "/trans",
    name: "trans",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "transfer" */ "../views/Transfer.vue"),
  },
  {
    path: "/crp",
    name: "CashReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "CashReport" */ "../views/ReportCashInOut.vue"
      ),
  },
  {
    path: "/pdiffer",
    name: "DifferencePrice",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "CashReport" */ "../views/DifferencePrice.vue"
      ),
  },
  {
    path: "/dailyinout",
    name: "dailyinout",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "dailyinout" */ "../views/ReportDailyCashInOut.vue"
      ),
  },
  {
    path: "/voucherslip",
    name: "voucherslip",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "voucherslip" */ "../views/VoucherSlip.vue"),
  },
  {
    path: "/repayment",
    name: "repayment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "repayment" */ "../views/ReportPayment.vue"),
  },
  {
    path: "/rpmanu",
    name: "rpmanu",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "rpmanu" */ "../views/ReportManufacturingMonth.vue"
      ),
  },
  {
    path: "/history",
    name: "history",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "history" */ "../views/History.vue"),
  },
  {
    path: "/barcodescan",
    name: "barcodescan",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "barcodescan" */ "../views/BarcodeScan.vue"),
  },
  {
    path: "/puritemlist",
    name: "puritemlist",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "puritemlist" */ "../views/PurchaseItemList.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
